import * as urlOBJ from 'url';

interface ParsedDomain {
  msg?: string;
  tld?: string;
  dtld?: string;
  domain?: string;
  subdomain?: string;
}

export function parseDomain(rawUrl): ParsedDomain {
  const matches = rawUrl.match(/https?:\/\/(www\.)?[^/]+/);

  if (!matches) {
    return {
      msg: `invalid url: ${rawUrl}`,
    };
  }

  const url = matches[0].replace(/www\./ig, '');

  let urlSplit;
  let tld;
  let domain;
  let subdomain;

  if (!url || typeof url !== 'string') {
    return null;
  }

  // Parse URL
  const obj = urlOBJ.parse(url);

  // check if tld is supported
  urlSplit = obj.host.split('.');
  tld = urlSplit[urlSplit.length - 1];
  domain = urlSplit.slice(urlSplit.length - 2, urlSplit.length - 1).join('.');
  subdomain = urlSplit.slice(0, urlSplit.length - 2).join('.');

  return {
    tld,
    domain,
    subdomain,
    dtld: (subdomain ? subdomain + '.' : '') + domain + '.' + tld,
  };
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/parseDomain.ts